<template>
    <div
        :class="styles.table"
        class="mb-4 bg-white"
    >
        <div
            :class="[styles.table_first_td, classStyles['text-secondary_color-500']]"
            class="flex justify-between p-4"
        >
            <h2 class="self-center text-2xl sm:text-3xl">{{ title }}</h2>
            <div>
                <slot name="action"></slot>
            </div>
        </div>
        <table class="w-full table-fixed border-collapse">

            <tbody class="text-gray-800">
            <tr
                v-for="(element, index) in content"
                :key="index"
                :class="[index === content.length - 1 ? styles.table_last_tr : styles.table_tr]"
            >
                <td
                    :class="[index === Object.keys(content).length - 1 ? styles.table_last_left_td : '']"
                    class="ml-4 p-3"
                    v-text="element.name"
                ></td>
                <td
                    :class="[index === Object.keys(content).length - 1 ? styles.table_last_right_td : '']"
                    class="ml-4 p-3"
                >
                    <div
                        v-if="element.value"
                        class="overflow-x-auto"
                        v-html="element.value"
                    ></div>
                    <div
                        v-else
                        class="overflow-x-auto"
                    >
                        <slot :name="element.slug"></slot>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    title: String,
    content: Array
  },

  data () {
    return {
      styles: window.myStyles,
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
